import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { URLsConfig } from '../URLsConfig';
import { LkpRevenueModel } from '../models/LkpRevenueModel';
@Injectable({
  providedIn: 'root'
})
export class LkpRevenueService {
  constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
  }

  public getRevenue(revcode: string , compCode: string) {

    let params = new HttpParams();
      params = params.append("RevCode", revcode);
      params = params.append("compCode", compCode);
      const options = {
        params: params
    };
    return this.http.get<LkpRevenueModel>(this.urlsconfig.WebAPIURL_Test + 'api/LkpRevenue/GetRevenue',options);
  }

  public AddRevenue(revenue: LkpRevenueModel) {
    return this.http.post<LkpRevenueModel>(this.urlsconfig.WebAPIURL_Test + 'api/LkpRevenue/AddRevenue', revenue);
  }

  public DelRevenue(revcode: string , compCode: string) {

    let params = new HttpParams();
      params = params.append("RevCode", revcode);
      params = params.append("compCode", compCode);
      const options = {
        params: params
    };
    return this.http.get<LkpRevenueModel>(this.urlsconfig.WebAPIURL_Test + 'api/LkpRevenue/DeleteRevenue',options);
  }

  public getRevenueLookupTop(compCode: string) {

    let params = new HttpParams();
    params = params.append("compcode", compCode);
    const options = {
      params: params
    };

    return this.http.get<LkpRevenueModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/LkpRevenue/RevenueLookupTop', options);
  }

}
